module.exports = __webpack_public_path__ + "img/15.26.19 反光衣违规预警.660d4bd2.png";